export default __webpack_public_path__ + "static/tri-weby-fae9710a9f0e19ac5da1baa1adaa2c93.png";